import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import Type from "../../../Global/Typography.js";
import WrapperList from "../../../Nano/WrapperList.js";
import ListLine from "../../../Nano/ListLine.js";

const DataList = (props) => (!props.data ? null : props.data.map((obj, i) => <ListLine key={i} titleLine={obj.title} infoLine={obj.info} isHref={obj.isHref} />));

const multiple = nota.global.multiple;

const StyledCardInfoBlock = styled(NanoFlex)`
  .listTopBarWrapper {
    padding: ${multiple + "px"};
    background-color: ${nota.color.neutral.NeuFive};
    flex-wrap: wrap;
    p {
      &:after {
        content: "|";
        font-size: 15px;
        display: inline-block;
        margin: 0 ${multiple / 2 + "px"};
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    h5 {
      color: ${nota.color.neutral.NeuOne};
      text-transform: uppercase;
    }
  }
`;

export class CardInfoBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  createDataList = (apiGetCardObj) => {
    let mainOutput = [];
    const mainInfoTitles = Object.keys(this.translation.card.mainInfoTitles);

    mainInfoTitles.forEach((key, i) => {
      if (apiGetCardObj[key] !== null) {
        mainOutput.push({
          key,
          title: this.translation.card.mainInfoTitles[key],
          info: apiGetCardObj[key],
          isHref: key === "programmePage",
        });
      }
    });

    return { mainOutput };
  };

  onClickSearch = (obj) => {
    return window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "SearchFromCard", filter: obj } }));
  };

  render() {
    const cardOutput = this.createDataList(this.props.card);

    return (
      <StyledCardInfoBlock flexDirection={"column"} className="cardInfoWrapper keywordsDescriptionBlock">
        {this.props.card.keywords && (
          <NanoFlex className="listTopBarWrapper" justifyContent={"flex-start"} alignItems={"flex-end"} alignContent={"flex-start"}>
            {this.props.card.keywords.filter((v) => v.name !== null && v.name.trim() !== "").map((item) => {
              return (
                <Type.p key={"Keywords_" + item.id} className="keywordItem clickableSearch" onClick={() => this.onClickSearch({ selectedKeywords: [item.id] })}>
                  <b>{item.name}</b>
                </Type.p>
              );
            })}
          </NanoFlex>
        )}
        {(cardOutput?.mainOutput?.length > 0 || this.props.card.description) /*|| this.props.card.evaluation*/ && (
          <WrapperList simple className="wrapperList">
            <NanoFlex flexDirection={"column"}>
              {this.props.card.description && (
                <NanoFlex className="listRow" justifyContent="flex-start">
                  <Type.p justify>{this.props.card.description}</Type.p>
                </NanoFlex>
              )}
              {cardOutput?.mainOutput?.length > 0 && <DataList data={cardOutput.mainOutput} />}
              {/* {this.props.card.evaluation && (
                <NanoFlex className="listRow evaluationContainer" justifyContent="flex-start">
                  <Type.p justify>{this.props.card.evaluation}</Type.p>
                </NanoFlex>
              )} */}
            </NanoFlex>
          </WrapperList>
        )}
      </StyledCardInfoBlock>
    );
  }
}

//Set default props
CardInfoBlock.defaultProps = {
  card: {},
};

export default CardInfoBlock;

// --- // Documentation // --- //
/*
  import KeywordsDescriptionBlock from './../Partial/KeywordsDescriptionBlock.js';
  
  <KeywordsDescriptionBlock/>
  */
